function Skill({source, alt, title}) {
    return  <img src={source} alt={alt} title={title} className="skillImg"/>
}

export default Skill